import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey } from 'service/hooks/queryKeys'
import endpoint from 'service/api/products/random/index'
import { useAtom } from 'jotai'
import { googleCredentialAtom } from 'store/atoms'

const useGetRandomProduct = () => {
  const queryClient = useQueryClient()
  const [googleCredential] = useAtom(googleCredentialAtom)
  return useMutation({
    mutationKey: [QueryKey.GET_RANDOM_PRODUCT],
    mutationFn: (args: { total?: number }) =>
      endpoint({
        params: { ...args, 'google-token': googleCredential?.credential }
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_PRODUCT] })
    }
  })
}

export { useGetRandomProduct }
